import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-collapse"
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Check if there's a saved state in sessionStorage
    const key = this.storageKey
    const savedState = sessionStorage.getItem(key)

    if (savedState === "closed") {
      this.close()
    } else {
      this.open()
    }
  }

  toggle() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.open()
      sessionStorage.setItem(this.storageKey, "open")
    } else {
      this.close()
      sessionStorage.setItem(this.storageKey, "closed")
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.iconTarget.classList.add("rotate-180")
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.iconTarget.classList.remove("rotate-180")
  }

  get storageKey() {
    // Use element id or a data attribute as unique key
    return `sidebar-collapse-${this.element.dataset.sectionId || this.element.id || 'default'}`
  }
}
